import {useNeoContext} from "@/context/neo/neo.context";
import {FleetService} from "@/service/fleet.service";
import React, {useEffect, useState} from "react";
import GenericWidget from "../widgets/GenericWidget";
import WidgetData from "../widgets/Widget-data";

const ServiceWidget: React.FC = () => {
  const {filterContext} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState("");

  useEffect(() => {
    if (filterContext?.client?.institutionUserId) {
      setLoginUserId(filterContext.client.institutionUserId);
    }
  }, [filterContext]);

  return (
    <GenericWidget
      title="Service Types"
      icon="/images/service_yellow.svg"
      type={3}
      fetchService={FleetService.getfleetdatas}
      addService={FleetService.addfleetdata}
      updateService={FleetService.updatefleetdata}
      deleteService={FleetService.deletefleetdata}
      renderEmptyImage="/images/serviceGroup.svg"
      emptyText="No service type added yet"
      actionText="Service Type"
      WidgetContent={WidgetData}
      loginUserId={loginUserId}
      apiresponsekey="repairExpenseTypes"
    />
  );
};

export default ServiceWidget;
